// Dev-only: cache translation namespaces for the dev-server lifetime so we don't
// re-fetch from the remote endpoint on every SSR render. Not used in production.
const __devTranslationCache = {};

module.exports = {
  locales: ['__default', 'en-GB', 'en-US', 'cy'],
  defaultLocale: '__default',
  localesToIgnore: ['__default'],
  defaultNS: 'microsite',
  loader: false,
  pages: {
    '*': [
      'microsite',
      'proaccount',
      'appCommon',
      'appDetails',
      'search',
      'appCard',
      'common',
      'user',
    ],
  },
  loadLocaleFrom: (locale, namespace) => {
    const translationsBaseUrl =
      process.env.TRANSLATIONS_BASE_URL ??
      process.env.NEXT_PUBLIC_TRANSLATIONS_BASE_URL;
    const url = `${translationsBaseUrl}${locale}/${namespace}.json`;
    const fetchJson = () => fetch(url).then((res) => res.json());

    // Dev only: fetch each namespace once per dev-server lifetime.
    if (process.env.NODE_ENV !== 'production') {
      if (!__devTranslationCache[url]) {
        __devTranslationCache[url] = fetchJson();
      }
      return __devTranslationCache[url];
    }

    return fetchJson();
  },
};
